import { Phone } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { brand, waLink, gallery } from "@/content/site";
import { Reveal, Label, WhatsAppIcon, Arrow } from "@/components/apex/primitives";

const ContactCta = () => {
  const { t, isRtl } = useLang();
  const img = gallery.find((g) => g.id === "apex-marble-portal") || gallery[0];

  return (
    <section id="contact" data-testid="contact-section" className="relative py-6 sm:py-10">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal>
          <div className="ap-dark grid overflow-hidden rounded-[2rem] lg:grid-cols-[1.1fr_0.9fr]">
            <div className="flex flex-col justify-center p-8 sm:p-12 lg:p-16">
              <div>
                <Label dark>{t.contact.label}</Label>
              </div>
              <h2 className="ap-display mt-6 text-[2.1rem] text-white sm:text-[2.7rem] lg:text-[3.2rem]">
                {t.contact.title}
              </h2>
              <p className="mt-5 max-w-xl text-[15px] leading-[1.9] text-white/65 sm:text-base">{t.contact.body}</p>

              <div className="mt-9 flex flex-wrap items-center gap-4">
                <a
                  href={waLink(t.float.defaultMsg)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-whatsapp"
                  className="ap-btn"
                >
                  <WhatsAppIcon className="h-5 w-5" />
                  {t.contact.wa}
                  <Arrow />
                </a>
                <a href={brand.telUrl} data-testid="contact-call" className="ap-btn-white">
                  <Phone className="h-4 w-4" strokeWidth={2} />
                  {t.contact.call}
                </a>
              </div>
            </div>

            <div className="relative min-h-[320px] lg:min-h-full">
              <img
                src={img.src}
                alt={isRtl ? img.alt_ar : img.alt_en}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 h-full w-full object-cover"
                style={{ objectPosition: "center 40%" }}
              />
              <div
                className="absolute inset-0 bg-[linear-gradient(to_right,var(--charcoal),transparent_35%)] rtl:bg-[linear-gradient(to_left,var(--charcoal),transparent_35%)]"
                aria-hidden="true"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactCta;
